import {ChildEntity} from "typeorm";
import {Competition} from ".";

@ChildEntity()
export class FriendlyCompetition extends Competition {
}
